{"title":"{{ pet_name }} ist außerdem ...","dog":"ein Hund","cat":"eine Katze"}